import { render, staticRenderFns } from "./applications.vue?vue&type=template&id=5f8a2e2e&scoped=true&"
import script from "./applications.vue?vue&type=script&lang=js&"
export * from "./applications.vue?vue&type=script&lang=js&"
import style0 from "./applications.vue?vue&type=style&index=0&id=5f8a2e2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8a2e2e",
  null
  
)

export default component.exports